import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import React,{ useState,useRef,useCallback , useEffect} from 'react';
import FormContainer from '../components/FormContainer';
import { CusFormLabel, FormTitle, FormUploadView} from '../validation/Form-Components';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import config from '../appconfig/config.json';
import service from '../services/ApiService.js';
import uploadService from '../services/UploadFilesService.js';
import Loading from '../components/Loading';
import ImgPopup from '../components/ImgPopup';
import CusToast from '../components/CusToast';
import uploadConfig from '../data/uploaddetailsdata.json';
import helper from '../factory/Helper.js';
import {  Error  } from '@progress/kendo-react-labels';
import ReactCrop from 'react-image-crop';
import '../styles/ReactCrop.css';
import {Button} from '@progress/kendo-react-buttons';
import cropper from '../factory/cropper';
import { isMobile } from 'react-device-detect';
import CusSignPad from '../components/CusSignPad';

let signatureId='0',imgStr = '';
const UploadDetails = (props) => {
    var _URL = window.URL || window.webkitURL;
    let timer;
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 80 };
    const detailsType = '7';
    const typeSignature='Signature';
    const [selectedFile, setSelectedFile] = useState([]);
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);  //to show api call

    const [isSaveDone, setIsSaveDone] = useState(false);
    const [uploadedSignature,setUploadedSignature] = useState();
    const [showImgPopup,setShowImgPopup] = useState(false);

    const [uploadSignErr,setUploadSignErr] = useState(false);
    const [signErrMsg,setSignErrMsg] = useState('');

    const initResState = {
        RefNum:'',
        CompDtls:{}, 
        ApplicantDtls:[],
        ApplicantsDtlsMyInfo:{},
        DocSubmit:{}
    }

    const [response, setResponse] = useState(initResState);

    
    //crop
    const [imgExt,setImgExt] = useState();
    const [upImg, setUpImg] = useState();
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const percentCrop ={unit: '%', width: 80, height:55, x:10, y:20};
    const mobileCrop ={unit: '%', width: 90, height:80, x:5, y:10};
    const [crop, setCrop] = useState(isMobile? mobileCrop:percentCrop);
    const [completedCrop, setCompletedCrop] = useState(null);
    const [signFile,setSignFile] = useState([]);
    const [buttonPopup, setButtonPopup] = useState(false);

    //signpad
    const sigPad = useRef(null);
    let datafromsignPad;

    useEffect(() => {
        console.log('@UploadDetails useEffect');
       
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        window.scrollTo(0,0);
        getData();
        return () => clearTimeout(timer);
     }, []);

    const getData = () => {

        service.get().then( res => {
        
            if(res.data.isSucess){
                bindFormData(res.data.model.fields.request)
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
        })
    }

    const bindFormData =(data) => {
        try{
            setResponse(data);
            if(data.DocSubmit.Doc) {
                setIsSaveDone(true);
                signatureId = data.DocSubmit.Doc.id;
                setSelectedFile(getDefFileArray(data.DocSubmit.Doc.File));
                setUploadedSignature(data.DocSubmit.Doc.File);
            }
            else {
                setIsSaveDone(false);
                signatureId='0'
            }
        }
        catch(ex){

        }

        setIsLoading(false);
    }

    const getDefFileArray = (file) => {
 
        let fileArray = [];
        let fileData = {
            extension:file.extension,
            name:file.name,
            progress: parseInt(file.progress),
            size: parseInt(file.size) ,
            status:parseInt(file.status),
            uid:file.uid
        }
        fileArray.push(fileData);

        return fileArray;
    }
 
    const handleSubmit = () => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        

        if(uploadSignErr) {
            showErrMsg(config.error.UploadDetails.SignCropFailed);
            return;
        }
 
        saveUploadDetails(formatJsonParams(selectedFile),true);
    }

    const uploadFileOnChange = (file) => {
    
        setIsUploading(true);
        let rawFile = file[0].getRawFile();
        let docName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+file[0].extension;
      
        uploadService.uploadFiles(rawFile,response.RefNum,docName,typeSignature,signatureId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) { 
                signatureId = resData.model.id;
                saveUploadDetails(formatJsonParams(file),false);
            }
            else{
                setIsUploading(false);
                setIsSaveDone(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            console.log(err);
            setIsUploading(false);
            setIsSaveDone(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        })
    }

    const getUploadFile = (refNo,docType,docId) => {
        setIsUploading(true);
        uploadService.getFile(refNo,docType,docId).then( res => {
            if(res.data.isSucess) {
             
                setIsUploading(false);
 
                imgStr = 'data:image/png;base64,'+res.data.model.imageFields;
                setShowImgPopup(true);
            }
            else{
                setIsUploading(false);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsUploading(false);
        })
    }

    const formatJsonParams = (fileData) => {
        let params = {
            DocSubmit:{
                CurrentUser:currentUser(),
                AdoptAcraTemplate:null,
                Doc:formatDocJson(fileData)
            }
        }

        return params;
    }

    const saveUploadDetails = (params,isGoNext) => {
        setIsUploading(true);
        service.post(detailsType,params).then( res => {
            setIsUploading(false);
            hideSignErrMsg();
            let resData = res.data;
            if(resData.isSucess) {
                setButtonPopup(false);
                if(isGoNext){
                    goNext();
                }
                else {
                    setIsSaveDone(true);
                    setUploadedSignature(params.DocSubmit.Doc.File);
                }
                hideSignErrMsg();
            }
            else {
                setButtonPopup(false);
                setIsSaveDone(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }          
        })
        .catch(err => {
            console.log("err =>",err);
            setButtonPopup(false);
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }

    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:null,
            Order:null
        }
        return params;
    }

    const formatDocJson = (file) =>{
        let doc;
        if(file.length !== 0){
            doc = {
                DocType: typeSignature,
                DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+file[0].extension,
                id: signatureId,
                NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                Name:response.ApplicantsDtlsMyInfo.Name,
                File:{
                    extension:file[0].extension,
                    name:file[0].name,
                    progress:file[0].progress,
                    size: file[0].size,
                    status: file[0].status,
                    uid: file[0].uid
                }
            }
        }
        return doc;
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            // history.push(config.route.DeclarationDetails);
            history.push(config.route.AcctOpeningMY);
        }
    }

    const validate = (data) => {
        try{
            let isValid = false;
            if(data.length !== 0) {
                let fileObj = data[0];
                let size = fileObj.size;
                let extn = fileObj.extension.toLowerCase();
                 if(extn === '.png' || extn === '.jpg' || extn === '.jpeg'){
                    if(size <= 3145728) {
                        isValid = true;
                    }
                    else {
                        isValid = false;
                    }
                 }
                 else { 
                     isValid = false;
                 }
            }
            else{
                isValid = false;
            }
     
            return isValid;
        }catch(ex){

        }
    }

    const onHandleChange = (data) => {

        setCrop(isMobile? mobileCrop:percentCrop);
        hideSignErrMsg();
        setSelectedFile(data.value);
        setSignFile(data.value);
        if(data.value.length > 0){
            if(validate(data.value)) {
                if(data.value[0].getRawFile){
                    if(!config.EnableSignatureCropping) {  //signature cropping disable
                        uploadFileOnChange(data.value); 
                    }
                    else { //signature cropping enable
                        var vfile, img;
                        if ((vfile = data.value[0])) {
                            img = new Image();
                            var objectUrl = _URL.createObjectURL(data.value[0].getRawFile());
                           
                            img.onload = function (e) {
                                
                                if(this.width < 640 || this.height < 480) {
                                    showErrMsg('Your signature image is ('+this.width+'px X '+this.height+'px) dimension. '+uploadConfig.errMsg.minImgDimension);
                                    showSignErrMsg('Your signature image is ('+this.width+'px X '+this.height+'px) dimension. '+uploadConfig.errMsg.minImgDimension);
                                    setSelectedFile([]);
                                }
                                else {
                                    cropSignature(data);
                                }
                         
                                _URL.revokeObjectURL(objectUrl);
                            };
                            img.src = objectUrl;
                        }
                    }
                }
            }
            else {
                setSelectedFile([]);
                showErrMsg(uploadConfig.errMsg.imgSize3MB);
                showSignErrMsg(uploadConfig.errMsg.imgSize3MB);
            }  
        }
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
      //  setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const showSignErrMsg = (msg) => {
        setUploadSignErr(true);
        setSignErrMsg(msg);
    }
    
    const hideSignErrMsg = () => {
        setUploadSignErr(false);
        setSignErrMsg('');
    }

      //crop signature

      const isValidCropImg = (completedCrop) => {
        let valid = true;
        let width = completedCrop.width.toFixed();
        let height = completedCrop.height.toFixed();
        if(width < 250 && height < 250) {
            // console.log('crop img small')
            showErrMsg(uploadConfig.errMsg.cropImgSmall);
            valid = false;
        }
        else if(width > 400 && height > 400) {
            // console.log('crop img big')
            showErrMsg(uploadConfig.errMsg.cropImgLarge);
            valid = false;
        }
        else {
            valid = true;
        }
        return valid;
    }

    const cropSignature = (data) => {
        setButtonPopup(true)
        let fContent = data.value[0].getRawFile();
        let reader = new FileReader();
        reader.addEventListener('load', () => {
            setUpImg(reader.result);
            setImgExt(helper.extractImgFileExtensionFromBase64(reader.result));
        });
        reader.readAsDataURL(fContent);
    }

    const onImgLoad = useCallback((img) => {
       imgRef.current = img;
    }, []);

 
      const cancelImgCrop = (e) => {
        e.preventDefault();
        setButtonPopup(false);
        setCrop(isMobile? mobileCrop:percentCrop); 
        showSignErrMsg(config.error.UploadDetails.SignCropFailed);
      }
  
      const saveImgCrop = (e) => {
        
        e.preventDefault();
        
        if(!previewCanvasRef.current || !completedCrop) {
          return;
        }

        if(!isMobile) {
            if(!isValidCropImg(completedCrop)){
                return;
            }
        }
        const canvas = cropper.getCroppedImg(completedCrop, previewCanvasRef,imgRef);
        const base64Image = cropper.getResizeb64Img(completedCrop,canvas,imgExt);
        let binaryFile = helper.dataURLtoFile(base64Image,signFile[0].name);
        let docName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+signFile[0].extension;

        setIsUploading(true);
 
        uploadService.uploadFiles(binaryFile,response.RefNum,docName,typeSignature,signatureId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) { 
                signatureId = resData.model.id;
                setSelectedFile(signFile);
                saveUploadDetails(formatJsonParams(signFile),false);
            }
            else{
                setIsUploading(false);
                setIsSaveDone(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            console.log(err);
            setIsUploading(false);
            setIsSaveDone(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        })
 
      }
      //crop signature end

      //sign pad start
      const clearSignPad = (e) => {
        e.preventDefault();
        resetSignPad();
        hideSignErrMsg();
      }

      const resetSignPad = () => {
        if(isMobile){
            sigPad.current.clear();
        }
      }

      const saveSignPad = (e) => {
        e.preventDefault();
        if (sigPad.current.isEmpty()) {
            showErrMsg("Please provide your e-sign.");
            showSignErrMsg("Please provide your e-sign.");
            return;
        } else {
            setIsUploading(true);
            datafromsignPad = sigPad.current.getTrimmedCanvas().toDataURL();
            datafromsignPad = datafromsignPad.replace(/^data:image\/[a-z]+;base64,/, "");
            uploadSignPadImg(datafromsignPad);
        }
      }

      const handleViewSignImg = (e)=> {
        e.preventDefault();
        getUploadFile(response.RefNum,typeSignature,signatureId);
      }

      const uploadSignPadImg = (b64ImgData) => {
        let docName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+'.png';
        uploadService.uploadB64ImgFile(b64ImgData,response.RefNum,docName,typeSignature,'png',signatureId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) { 
                signatureId = resData.model.id;
                let doc = {
                    DocType: typeSignature,
                    DocName: docName,
                    id: signatureId,
                    NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                    Name:response.ApplicantsDtlsMyInfo.Name,
                    File:{
                        extension:'.png',
                        name: signatureId+'_'+typeSignature+'.png',
                        progress:0,
                        size:signatureId,
                        status: 2,
                        uid: response.RefNum
                    }
                }
        
                let params = {
                    DocSubmit:{
                        CurrentUser:currentUser(),
                        AdoptAcraTemplate:null,
                        Doc:doc
                    }
                }
                setSelectedFile(getDefFileArray(doc.File))
                saveUploadDetails(params,false);
            }
            else{
                setIsUploading(false);
                setIsSaveDone(false);
                resetSignPad();
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            console.log(err);
            setIsUploading(false);
            setIsSaveDone(false);
            resetSignPad();
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        })
      }
      //sign pad end

    if(isLoading) {
        return(
            <Loading />
        )
    }
    
    return(
        <div className="container-fluid">
           <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2>
                    </div>
                </div>
            </div>
            <br/>
            <Form onSubmitClick={handleSubmit}
                render={(formRenderProps) => (
                <FormElement>
                <FormContainer>
                    <fieldset>
                        <Field component={FormTitle} id={'ft1'} name={'Your Additional Business Details'}/> 
                        <FieldWrapper style={{paddingBottom:'20px'}}>
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblBizName'} leftLabelName={'Business Former Name'}
                                id={'BizName'} name={response.CompDtls.FormerName!==null?response.CompDtls.FormerName:'Not applicable'} />
                        </FieldWrapper>
                    </fieldset>
                </FormContainer>
               
                <FormContainer>
                    <fieldset>
                        <Field component={FormTitle} id={'ft2'} name={'Upload Supporting Documents'} /> 

                        {isMobile === false?
                        <Field id={'Doc'} name={'Doc'} isTooltipImg={true}
                            label={'An image of your signature'}
                            tooltipPosition={'right'} tooltipAchor={'target'} tooltipTitle={'Sign in black on white piece of paper.'}
                            tooltipDesc={config.EnableSignatureCropping? uploadConfig.label.signTTip:uploadConfig.label.signTTipWOCrop}
                            component={FormUploadView} 
                            disabled={buttonPopup}
                            defaultFiles={selectedFile}
                            onChange={onHandleChange}
                            isFileUploaded={isSaveDone && uploadedSignature? true:false}
                            uploadedFileName={isSaveDone && uploadedSignature? uploadedSignature.name:''}
                            onViewClick={e => {
                                e.preventDefault();
                                getUploadFile(response.RefNum,typeSignature,signatureId);
                            }}  />
                        :
                        <div>
                            <CusSignPad sigPadRef={sigPad}
                                showViewBtn={isSaveDone && uploadedSignature? true:false}
                                onClickCear={clearSignPad}
                                onClickSave={saveSignPad}
                                onClickView={handleViewSignImg}
                            />
                        </div>
                        }

                        {uploadSignErr && 
                         <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <Error id={'errId1'}>{signErrMsg}</Error> 
                            </div>
                         </div>}  

                        <FieldWrapper>
                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />
                        <div className="row around-xs inputPair elementVisible">
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                <button className="btn btn-back" onClick={()=>{ history.push(config.route.TaxDetails)}}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!selectedFile.length > 0}>{config.btnName.Next}</button>
                            </div>
                        </div> 
                        
                        </FieldWrapper>
                      
                     
                    </fieldset>
              
                </FormContainer>
               
                <ImgPopup popupTitle={uploadedSignature? uploadedSignature.name:'Preview'} popupValue={showImgPopup} data={imgStr} setTrigger={setShowImgPopup}  />
                {buttonPopup &&
                <div className='popup-container'>
                    <div className='popup-container-inner'>
                    <div className='popup-container-inner-dot'>
                       <ReactCrop 
                           src={upImg}
                           onImageLoaded={onImgLoad} 
                           ruleOfThirds={true}
                           crop={crop}
                           onChange={(c) => setCrop(c)}
                           onComplete={(c) => setCompletedCrop(c)} />
                    </div>
                   
                    <div className='inputPairSubTitle'>
                        <div>{signFile.length !==0? signFile[0].name:''} </div>
                        <div>Please crop your signature clearly. Then, click on the <b>Save</b> button to proceed</div>
                        <br/>
                        {!completedCrop? null: <div>{'Cropped image dimension: '+ completedCrop.width.toFixed()+'x'+completedCrop.height.toFixed()}</div>}
                    </div>
                    <div className="row">
                        <div className="col-6" style={{ textAlign: "left"}}>                        
                            <Button look="outline" className="btSize1" onClick={cancelImgCrop}>Cancel</Button>
                        </div> 
                        <div className="col-6" style={{ textAlign: "right"}}>                        
                            <Button primary={true}  className="btSize1 btRht greenbtn2" disabled={!completedCrop?.width || !completedCrop?.height} onClick={saveImgCrop}>Save</Button>
                        </div>
                    </div>
                    </div>
                     <div style={{paddingTop:'10px', textAlign:'center',position:'absolute',visibility:'hidden'}} >
                       <canvas
                           ref={previewCanvasRef}
                           // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                           style={{
                           width: Math.round(completedCrop?.width ?? 0),
                           height: Math.round(completedCrop?.height ?? 0)
                       }} />
                    </div>  
                </div>
                }
            </FormElement>
            )}>
           </Form>
           {isUploading && <Loading />}
           <CusToast trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
        </div>
    )
}

export default UploadDetails;